import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing20,
  spacing24,
  spacing32,
} from 'approot/shared/styles/spacing.style';
import {
  borderRadius16,
  boxShadowBlack12,
} from 'approot/shared/styles/borders.style';
import {
  ACTIVITY_BUILDER_A4_LONG_SIDE,
  SLIDE_HEIGHT_MINUS_HEADER_FOOTER,
} from './activity-builder.constants';
import { flexSpaceBetweenCss } from 'approot/shared/styles/flex.style';

export const SLIDE_CONTAINER_PADDING = 40;

export const ActivityBuilderRow = styled.div`
  max-width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE + SLIDE_CONTAINER_PADDING)};
  margin: auto;
  width: 100%;
`;

export const ActivityBuilderSlide = styled.div`
  ${boxShadowBlack12}
  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius16)};
  position: relative;
  width: 100%;

  @media (min-width: 1401px) {
    height: ${rem(SLIDE_HEIGHT_MINUS_HEADER_FOOTER)};
  }
`;

export const ActivityBuilderSlideRow = styled(ActivityBuilderRow)`
  position: relative;
  // if these padding values change adjust SLIDE_CONTAINER_PADDING
  padding: 0 ${rem(spacing20)} ${rem(spacing20)} ${rem(spacing20)};
  width: 100%;
`;

type ActivityBuilderSlideContentProps = {
  $paddingTop?: number;
};
export const ActivityBuilderSlideContent = styled.div<ActivityBuilderSlideContentProps>`
  padding: ${({ $paddingTop = spacing24 }) => rem($paddingTop)}
    ${rem(spacing24)} ${rem(spacing24)} ${rem(spacing24)};
`;

export const ActivityBuilderSlideControlsRow = styled.div`
  ${flexSpaceBetweenCss}

  gap: ${rem(spacing8)};
  max-width: ${rem(ACTIVITY_BUILDER_A4_LONG_SIDE + SLIDE_CONTAINER_PADDING)};
  margin-top: ${rem(spacing32)};
  padding: ${rem(spacing20)};
  position: relative;
  width: 100%;
`;
